module.exports = __webpack_public_path__ + "media/images/placeholder-courses-b9fd00ec.png";